const Tiktok = ({ color, width, height, styles, onClick }) => {
    const DEFAULT_WIDTH = '16px';
    const DEFAULT_HEIGHT = '16px';

    const handleLocalClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? DEFAULT_WIDTH}
            height={height ?? DEFAULT_HEIGHT}
            viewBox="0 0 14 14"
            onClick={handleLocalClick}
            style={{ cursor: 'pointer', ...styles }}
        >
            <g fill="none" stroke={color || 'currentColor'} strokeLinecap="round" strokeLinejoin="round">
                <path d="M5.671 6.655a1.99 1.99 0 1 0 1.99 1.99v-5.28c.308 1.321 1.195 2.242 2.658 2.242" />
                <path d="M.96 10.269a3.13 3.13 0 0 0 2.753 2.76c1.07.119 2.167.221 3.287.221s2.218-.102 3.287-.222a3.13 3.13 0 0 0 2.753-2.76c.114-1.063.21-2.155.21-3.268s-.096-2.205-.21-3.269a3.13 3.13 0 0 0-2.753-2.76C9.217.853 8.12.75 7 .75S4.782.852 3.713.972A3.13 3.13 0 0 0 .96 3.732C.846 4.794.75 5.886.75 7s.096 2.205.21 3.269" />
            </g>
        </svg>
    );
};

export default Tiktok;
